const themeEnum = {
    LOBBY: 3,
    TOURNAMENT: 1,
    TEAMGAME: 2,
};

Object.freeze(themeEnum);

export default themeEnum;
